import { createAction, handleActions } from "redux-actions";
import produce from "immer";
import { takeLatest, select, put, call, take } from "redux-saga/effects";
import createRequestSaga, { createRequestActionTypes } from "../createRequestSaga";
import * as userAPI from "api/@auth/api_auth";

// Action Type 정의
const INITIALIZE_FORM = "user/INITIALIZE_FORM";
export const CHANGE_USER_QUIZ = "user/CHANGE_USER_QUIZ";

const [GET_USERS, GET_USERS_SUCCESS, GET_USERS_FAILURE] = createRequestActionTypes("user/GET_USERS");
const [MODIFY_USER, MODIFY_USER_SUCCESS, MODIFY_USER_FAILURE] = createRequestActionTypes("user/MODIFY_USER");
const [CHECK_NICKNAME, CHECK_NICKNAME_SUCCESS, CHECK_NICKNAME_FAILURE] =
  createRequestActionTypes("user/CHECK_NICKNAME");

// ================== Handlers ================== //
export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const getUsers = createAction(GET_USERS, (token) => token);
export const checkNickname = createAction(CHECK_NICKNAME, (nickname) => nickname);

// saga 생성
export const getUsersSaga = createRequestSaga(GET_USERS, userAPI.getUsers);
export const checkNicknameSaga = createRequestSaga(CHECK_NICKNAME, userAPI.checkNickname);
export const modifyUser = createAction(MODIFY_USER, ({ user_id, form }) => ({
  user_id,
  form,
}));
const modifyUserSaga = createRequestSaga(MODIFY_USER, userAPI.modifyUser);

export function* userSaga() {
  yield takeLatest(GET_USERS, getUsersSaga);
  yield takeLatest(CHECK_NICKNAME, checkNicknameSaga);
  yield takeLatest(MODIFY_USER, modifyUserSaga);
}

const initialState = {
  add: {
    termsService: false,
    termsPrivacy: false,
    termsSensitivity: false,
    termsMarketing: false,
    birthyear: "",
    gender: "",
    nickname: "",
    phoneCountry: "82",
    phoneNumber: "",
    phoneNumberConfirm: "",
    // phoneNumber1: '10',
    // phoneNumber3: '',
    // 인증번호 코드 유저 입력
    verificationCode: "",

    // 인증번호 전송 유/무
    verificationCodeSent: false,

    // 인증번호 재전송 유/무
    verificationCodeResent: false,

    // 인증됌 --> 마지막 인증
    verified: null,

    hairlossType: "",
    scalpType: "",
    userAdded: null,
    phoneDuplicated: null,
    basicInfoAdded: null,
    profileAdded: null,
    nicknameDuplicated: null,
  },
  users: null,
  checkError: null,
  resultMsg: null,
  error: null,
};

export default handleActions(
  {
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      [form]: initialState[form],
      checkError: null, // 폼 전환 시 회원 인증 에러 초기화
    }),
    // user list 불러오기 성공
    [GET_USERS_SUCCESS]: (state, { payload: users }) => ({
      ...state,
      users: users.users,
    }),
    // user list 불러오기 실패
    [GET_USERS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      users: null,
      checkError: error,
    }),
    // 닉네임 중복검사 성공 (available 결과 값 -> true/false)
    [CHECK_NICKNAME_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      add: { ...state.add, nicknameDuplicated: res.duplicated },
    }),
    // 닉네임 중복검사 실패
    [CHECK_NICKNAME_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),

    // user 정보 수정 성공
    [MODIFY_USER_SUCCESS]: (state, { payload: user }) => ({
      ...state,
      error: null,
    }),
    // user 정보 수정 실패
    [MODIFY_USER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    //사용자 퀴즈 등록
    [CHANGE_USER_QUIZ]: (state, { data }) => ({
      ...state,
      users: [data],
    }),
  },
  initialState,
);

export const getUserId = (state) => {
  return state.user.users?.[0].user_id || null;
};

export const getUserName = (state) => {
  return state.user.users?.[0].nickname || null;
};
